import { StockMovement, StockRecipe } from 'types/models/StockMovement';
import { StockReception } from 'types/models/StockReceipt';

export function sumStockUnits(entity: StockMovement | StockReception | StockRecipe): number {
  const items = (entity.items ?? []) as unknown as Array<{ quantity: number }>;
  return items.reduce((sum, item) => sum + Number(item.quantity), 0);
}

/**
 * Valor monetario perdido en una merma (LOSS), calculado como la suma de cantidad × average_cost_snapshot por item.
 */
export function sumLossValue(entity: StockMovement): number | null {
  const items = entity.items ?? [];

  let total = 0;
  let hasSnapshot = false;

  for (const item of items) {
    if (item.averageCostSnapshot != null && item.averageCostSnapshot > 0) {
      total += Number(item.quantity) * item.averageCostSnapshot;
      hasSnapshot = true;
    }
  }

  return hasSnapshot ? total : null;
}
